import { render, staticRenderFns } from "./Representatives.vue?vue&type=template&id=79f2f4a6&scoped=true&"
import script from "./Representatives.vue?vue&type=script&lang=js&"
export * from "./Representatives.vue?vue&type=script&lang=js&"
import style0 from "./Representatives.vue?vue&type=style&index=0&id=79f2f4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f2f4a6",
  null
  
)

export default component.exports